import t, { useState as O } from "react";
import { useTranslation as w } from "react-i18next";
import h from "classnames";
import { useAuth as L } from "../../../auth/hooks/useAuth.js";
import { useStyle as b } from "../../../dom/hooks/useStyle.js";
import { usePhoneValidationFlow as $ } from "../../../auth/hooks/usePhoneValidationFlow.js";
import { PhoneVerification as D } from "../../../auth/components/phone/PhoneVerification/PhoneVerification.js";
import { PhoneInputForm as H } from "../../../auth/components/phone/PhoneInputForm/PhoneInputForm.js";
import { DuplicatePhoneError as W } from "../../../auth/components/phone/DuplicatePhoneError/DuplicatePhoneError.js";
import { Modal as q } from "../Modal/Modal.js";
import { VoucherRuleType as k, VoucherStatus as C, VoucherDetailedStatus as i, VoucherRedeemMethod as v } from "../../../api/models/voucher/voucherEnums.js";
import { QrCode as G } from "../QrCode/QrCode.js";
import { Barcode as Q } from "../Barcode/Barcode.js";
import { AddToWallet as X } from "../AddToWallet/AddToWallet.js";
import { useBurnVoucher as j } from "../../../api/repositories/vouchers/useBurnVoucher.js";
import { getDateTimeWithMonthName as z, getDateTime as d } from "../../../../utils.js";
import o from "./voucher.module.scss.js";
function _e({ voucher: e, modalDesign: n }) {
  var T;
  const { t: r } = w(), { token: I, reFetch: S, customer: E } = L(), a = {
    backgroundColor: (n == null ? void 0 : n.backgroundColor) ?? e.settings.backgroundColor,
    textColor: (n == null ? void 0 : n.textColor) ?? e.settings.textColor,
    primaryButtonBackgroundColor: (n == null ? void 0 : n.primaryButtonBackgroundColor) ?? e.settings.buttonColor ?? void 0,
    primaryButtonTextColor: (n == null ? void 0 : n.primaryButtonTextColor) ?? e.settings.textButtonColor ?? void 0,
    secondaryButtonBackgroundColor: n == null ? void 0 : n.secondaryButtonBackgroundColor,
    secondaryButtonTextColor: n == null ? void 0 : n.secondaryButtonTextColor,
    borderColor: n == null ? void 0 : n.borderColor,
    fontFamily: (n == null ? void 0 : n.fontFamily) ?? e.settings.font
  }, p = e.settings.font ?? "", f = a.fontFamily !== p ? a.fontFamily ?? "" : "";
  b(
    p ? `https://fonts.googleapis.com/css?family=${encodeURIComponent(p)}&display=swap` : ""
  ), b(
    f ? `https://fonts.googleapis.com/css?family=${encodeURIComponent(f)}&display=swap` : ""
  );
  const { mutate: P, isLoading: R } = j(), [F, y] = O(!1), c = e.settings.requiresVerifiedPhone && (((T = E == null ? void 0 : E.configuration) == null ? void 0 : T.needVerification) ?? !1), s = $({ onSaved: S }), V = e.getRedeemCodes(), g = e.settings.getRulesByType(
    k.USES_PER_TIME
  ), _ = e.settings.getRulesByType(
    k.SCHEDULE
  ), B = e.getAccessPointId(), x = B !== null && e.status === C.ACTIVE && !R && I !== null, A = () => {
    x && P({
      accessPointId: B,
      code: e.internalCode
    });
  };
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      "data-testid": "voucher",
      className: o.voucherWrapper,
      style: {
        "--textColor": e.settings.textColor,
        "--highlightTextColor": e.settings.highlightTextColor,
        "--backgroundColor": e.settings.backgroundColor,
        "--buttonColor": e.settings.buttonColor ?? "",
        "--spentButtonColor": e.settings.spentButtonColor ?? "",
        "--textButtonColor": e.settings.textButtonColor ?? "",
        "--fontFamily": e.settings.font ?? ""
      }
    },
    /* @__PURE__ */ t.createElement("div", { className: o.voucher }, /* @__PURE__ */ t.createElement(
      "div",
      {
        style: {
          backgroundImage: `url(${e.settings.image})`
        },
        className: o.voucher__image
      },
      c && /* @__PURE__ */ t.createElement("div", { className: o.voucher__pendingValidation }, r("voucher.pendingValidation")),
      !c && e.detailedStatus !== i.PASSED && /* @__PURE__ */ t.createElement("div", { className: o.voucher__error }, e.detailedStatus === i.INVALID_PROMOTION_SCHEDULED_RULE && /* @__PURE__ */ t.createElement("div", { className: o.voucher__error__small }, r("voucher.error.outOfSchedule")), e.detailedStatus === i.INVALID_PROMOTION_REACHED_MAXIMUM_USES && /* @__PURE__ */ t.createElement("div", { className: o.voucher__error__small }, r("voucher.error.noMoreUses")), (e.detailedStatus === i.INVALID_PROMOTION_SCHEDULED_RULE || e.detailedStatus === i.INVALID_PROMOTION_IS_NOT_PENDING || e.detailedStatus === i.INVALID_DATETIME || e.detailedStatus === i.INVALID_PROMOTION_USAGE_RULE) && e.nextActivationTimestamp && /* @__PURE__ */ t.createElement("div", { className: o.voucher__error__nextActivation }, r("voucher.error.nextActivation"), ":", /* @__PURE__ */ t.createElement("br", null), " ", z(
        e.nextActivationTimestamp
      )))
    ), !c && /* @__PURE__ */ t.createElement(
      "div",
      {
        className: h({
          [o.voucher__scannerCodes]: !0,
          [o.voucher__scannerCodes__disabled]: e.detailedStatus !== i.PASSED
        })
      },
      V.map((l, u) => {
        const m = `${l.code}-${l.type}-${u}`;
        return l.type === v.QR_CODE ? /* @__PURE__ */ t.createElement("div", { key: m, className: o.voucher__scannerCodes__qr }, /* @__PURE__ */ t.createElement(G, { data: l.code })) : /* @__PURE__ */ t.createElement(
          "div",
          {
            key: m,
            className: o.voucher__scannerCodes__barcode
          },
          /* @__PURE__ */ t.createElement(Q, { data: l.code })
        );
      })
    ), c && /* @__PURE__ */ t.createElement(
      "button",
      {
        className: o.voucher__verifyBtn,
        type: "button",
        disabled: !s.canStartFlow,
        onClick: () => s.openPhoneInputForm()
      },
      r("voucher.verify")
    ), /* @__PURE__ */ t.createElement("div", { className: o.voucher__title }, e.settings.title), /* @__PURE__ */ t.createElement("div", { className: o.voucher__info }, /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("div", { className: o.voucher__info__title }, (e.initialDate || e.initialDate === void 0 && e.expirationDate === void 0) && r("voucher.validFromTitle"), !e.initialDate && e.expirationDate && r("voucher.validUntilTitle")), /* @__PURE__ */ t.createElement("div", { className: o.voucher__info__content }, e.initialDate === void 0 && e.expirationDate === void 0 && d(/* @__PURE__ */ new Date()), e.initialDate && d(e.initialDate), !e.initialDate && e.expirationDate && d(e.expirationDate))), /* @__PURE__ */ t.createElement("div", { className: o.voucher__info__rightSide }, /* @__PURE__ */ t.createElement("div", { className: o.voucher__info__title }, r("voucher.remainingUsesTitle")), /* @__PURE__ */ t.createElement("div", { className: o.voucher__info__content }, e.settings.isUnlimited ? r("voucher.unlimited") : `${e.currentUses}/${e.settings.maximumUses}`))), !c && /* @__PURE__ */ t.createElement(X, { url: e.url.toString() }), !c && e.settings.redeemMethod === v.BUTTON && /* @__PURE__ */ t.createElement(
      "button",
      {
        className: h({
          [o.voucher__burnBtn]: !0,
          [o.voucher__burnBtn__active]: e.status === C.ACTIVE,
          [o.voucher__burnBtn__innactive]: e.status !== C.ACTIVE
        }),
        onClick: A,
        type: "button",
        disabled: !x
      },
      e.status === C.ACTIVE ? r("voucher.burnBtnText") : r("voucher.expiredBurnBtnText")
    )),
    /* @__PURE__ */ t.createElement("div", { onClick: () => y(!0), className: o.terms }, r("terms.title")),
    /* @__PURE__ */ t.createElement(
      q,
      {
        show: F,
        onClose: () => y(!1),
        design: {
          backgroundColor: e.settings.backgroundColor,
          textColor: e.settings.textColor,
          fontFamily: e.settings.font
        }
      },
      /* @__PURE__ */ t.createElement("div", { className: o.terms__modal }, !!e.settings.terms && /* @__PURE__ */ t.createElement("div", { className: o.terms__block }, /* @__PURE__ */ t.createElement("div", { className: o.terms__title }, r("terms.title")), /* @__PURE__ */ t.createElement("div", { className: o.terms__text }, e.settings.terms)), /* @__PURE__ */ t.createElement("div", { className: o.terms__block }, /* @__PURE__ */ t.createElement("div", { className: o.terms__title }, r("voucher.terms.usesAndLimitations")), /* @__PURE__ */ t.createElement("div", { className: o.terms__text }, e.settings.isUnlimited && r("voucher.unlimited"), (e.settings.maximumUses > 0 || g.length > 0) && /* @__PURE__ */ t.createElement(t.Fragment, null, e.settings.maximumUses > 0 && /* @__PURE__ */ t.createElement("div", null, e.settings.maximumUses, " ", r("voucher.terms.usesTotal")), g.length > 0 && /* @__PURE__ */ t.createElement(t.Fragment, null, r("voucher.terms.maximum"), " ", g.map((l, u, m) => /* @__PURE__ */ t.createElement("span", { key: `usesPerTimeRule-${u}` }, l.maximumUses, " ", r(`voucher.terms.usesTimeframe.${l.timeframe}`), u === m.length - 1 ? "" : ", ")))))), (e.initialDate || e.expirationDate || _.length > 0) && /* @__PURE__ */ t.createElement("div", { className: o.terms__block }, /* @__PURE__ */ t.createElement("div", { className: o.terms__title }, r("voucher.terms.schedule")), (e.initialDate || e.expirationDate) && /* @__PURE__ */ t.createElement("div", { className: o.terms__block }, /* @__PURE__ */ t.createElement("div", { className: o.terms__text }, e.initialDate && /* @__PURE__ */ t.createElement("div", null, r("voucher.validFromTitle"), ":", " ", /* @__PURE__ */ t.createElement("strong", null, d(e.initialDate))), e.expirationDate && /* @__PURE__ */ t.createElement("div", null, r("voucher.validUntilTitle"), ":", " ", /* @__PURE__ */ t.createElement("strong", null, d(e.expirationDate))))), _.length > 0 && /* @__PURE__ */ t.createElement("div", { className: o.terms_scheduleRules }, _.map((l, u) => {
        var m;
        return /* @__PURE__ */ t.createElement(
          "div",
          {
            key: `scheduledRules-${u}`,
            className: o.terms_scheduleRules__item
          },
          /* @__PURE__ */ t.createElement("div", null, (m = l.weekDays) == null ? void 0 : m.map((U, N, M) => /* @__PURE__ */ t.createElement(t.Fragment, { key: `scheduledRulesWeekdays-${N}` }, r(`weekdays.short.${U}`), N === M.length - 1 ? "" : ", "))),
          /* @__PURE__ */ t.createElement("div", null, l.fullDay && /* @__PURE__ */ t.createElement(t.Fragment, null, "24h"), !l.fullDay && /* @__PURE__ */ t.createElement(t.Fragment, null, l.startTime, " - ", l.endTime))
        );
      })), _.length === 0 && /* @__PURE__ */ t.createElement("div", { className: o.terms_scheduleRules }, /* @__PURE__ */ t.createElement("div", { className: o.terms_scheduleRules__item }, /* @__PURE__ */ t.createElement("div", null, r("voucher.terms.scheduleAllDays")), /* @__PURE__ */ t.createElement("div", null, "24h")))))
    ),
    /* @__PURE__ */ t.createElement(
      H,
      {
        show: s.showPhoneInputForm,
        onClose: s.closePhoneInputForm,
        onSubmit: s.submitPhone,
        errorMessage: s.phoneInputErrorMessage ? r(s.phoneInputErrorMessage) ?? "" : void 0,
        design: {
          backgroundColor: a.backgroundColor,
          textColor: a.textColor,
          primaryButtonBackgroundColor: a.primaryButtonBackgroundColor,
          primaryButtonTextColor: a.primaryButtonTextColor,
          secondaryButtonBackgroundColor: a.secondaryButtonBackgroundColor,
          secondaryButtonTextColor: a.secondaryButtonTextColor,
          fontFamily: a.fontFamily
        }
      }
    ),
    /* @__PURE__ */ t.createElement(
      D,
      {
        show: s.showPhoneVerification,
        phoneNumber: s.currentPhone,
        onClose: s.hidePhoneVerification,
        onSubmit: s.handlePhoneVerificationSubmit,
        onResend: s.handlePhoneVerificationResend,
        countdownSeconds: s.cooldownSeconds,
        errorMessage: s.errorMessage ? r(s.errorMessage) ?? "" : void 0,
        design: {
          backgroundColor: a.backgroundColor,
          textColor: a.textColor,
          buttonBackgroundColor: a.primaryButtonBackgroundColor,
          buttonTextColor: a.primaryButtonTextColor,
          secondaryButtonBackgroundColor: a.secondaryButtonBackgroundColor,
          secondaryButtonTextColor: a.secondaryButtonTextColor,
          borderColor: a.borderColor,
          fontFamily: a.fontFamily
        }
      }
    ),
    /* @__PURE__ */ t.createElement(
      W,
      {
        show: s.showDuplicatePhoneError,
        onClose: s.hideDuplicatePhoneError,
        design: {
          backgroundColor: a.backgroundColor,
          textColor: a.textColor,
          buttonBackgroundColor: a.primaryButtonBackgroundColor,
          buttonTextColor: a.primaryButtonTextColor,
          fontFamily: a.fontFamily
        }
      }
    )
  );
}
export {
  _e as Voucher
};
//# sourceMappingURL=Voucher.js.map
